export const GIF_EDIT_MAX_SOURCE_BYTES = 8 * 1024 * 1024
export const GIF_EDIT_MAX_SIDE = 2048
export const GIF_EDIT_MAX_LOGICAL_PIXELS = 3_000_000
export const GIF_EDIT_MAX_FRAMES = 150
export const GIF_EDIT_MAX_PATCH_PIXELS = 40_000_000
export const GIF_EDIT_MAX_FULL_PIXEL_FRAMES = 40_000_000
export const GIF_EDIT_MAX_OUTPUT_BYTES = 15 * 1024 * 1024
export const GIF_EDIT_MAX_GLOBAL_SAMPLE_PIXELS = 100_000
export const GIF_EDIT_MAX_STRAIGHTENING = 45
export const GIF_EDIT_RENDER_TIMEOUT_MS = 30_000
export const GIF_EDIT_OPAQUE_ALPHA_MIN = 128

export type GifEditLimitReason =
  | 'sourceBytes'
  | 'dimension'
  | 'logicalPixels'
  | 'frameCount'
  | 'patchPixels'
  | 'fullPixelFrames'
  | 'straightening'
  | 'outputBytes'
  | 'timeout'

export const GIF_EDIT_TOO_LARGE_MESSAGE =
  'This animation is too large to edit in this browser; the original is unchanged.'

export class GifEditAdmissionError extends Error {
  readonly reason: GifEditLimitReason

  constructor(
    reason: GifEditLimitReason,
    message = GIF_EDIT_TOO_LARGE_MESSAGE,
  ) {
    super(message)
    this.name = 'GifEditAdmissionError'
    this.reason = reason
  }
}

export const assertGifSourceByteLimit = (byteLength: number): void => {
  if (byteLength > GIF_EDIT_MAX_SOURCE_BYTES) {
    throw new GifEditAdmissionError('sourceBytes')
  }
}

export const toSafeIntegerProduct = (
  ...values: readonly number[]
): number | null => {
  let product = 1n
  for (const value of values) {
    if (!Number.isInteger(value) || value < 0) return null
    product *= BigInt(value)
    if (product > BigInt(Number.MAX_SAFE_INTEGER)) return null
  }
  return Number(product)
}
